<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Date Ranges</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.currDateFrom" :label="labels.currDateFrom" :data-vv-as="labels.currDateFrom"
                    data-vv-name="form.currDateFrom"></cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.currDateTo" :label="labels.currDateTo" :data-vv-as="labels.currDateTo"
                    data-vv-name="form.currDateTo"></cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.prevDateFrom" :label="labels.prevDateFrom" :data-vv-as="labels.prevDateFrom"
                    data-vv-name="form.prevDateFrom"></cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.prevDateTo" :label="labels.prevDateTo" :data-vv-as="labels.prevDateTo"
                    data-vv-name="form.prevDateTo"></cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.acctPeriodFrom" :label="labels.acctPeriodFrom" :data-vv-as="labels.acctPeriodFrom"
                    data-vv-name="form.acctPeriodFrom"></cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.acctPeriodTo" :label="labels.acctPeriodTo" :data-vv-as="labels.acctPeriodTo"
                    data-vv-name="form.acctPeriodTo"></cal-picker>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Filters</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('form.branch')" :data-vv-as="labels.branch"
                    data-vv-name="form.branch" append-icon="mdi-magnify" @click:append="showBranchHelpList=true" @click="showBranchHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.fund" :label="labels.fund" :error-messages="errors.collect('form.fund')" :data-vv-as="labels.fund"
                    data-vv-name="form.fund" append-icon="mdi-magnify" @click:append="showFundHelpList=true" @click="showFundHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType"
                    data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="showPolTypeHelpList=true" @click="showPolTypeHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.busCls" :label="labels.busCls" :error-messages="errors.collect('form.busCls')" :data-vv-as="labels.busCls"
                    data-vv-name="form.busCls" append-icon="mdi-magnify" @click:append="showBusClsHelpList=true" @click="showBusClsHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="form.riType" :items="riTypeList" :label="labels.riType" item-text="label" item-value="value" @change="riTypeChanged"/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.riCo" :label="labels.riCo" :error-messages="errors.collect('form.riCo')" :data-vv-as="labels.riCo"
                    data-vv-name="form.riCo" append-icon="mdi-magnify" @click:append="showRiCoHelpList=true" @click="showRiCoHelpList=true" readonly
                    :disabled="riCoDisabled"/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="form.sortOrder" :items="sortOrderList" :label="labels.sortOrder" item-text="label" item-value="value" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Report Settings</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-select v-model="form.reportType" :items="reportTypeList" :label="labels.reportType" item-text="label" item-value="value" />
                </v-flex>
                <v-flex xs12>
                  <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
                    data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showBusClsHelpList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="form.busCls" @close="doClose" @doAssign="doAssignBusCls($event)" />
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)" />
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)" />
    </v-dialog>
    <v-dialog v-model="showRiCoHelpList" width="900px" persistent>
      <multi-ri-co-help-list :riType="form.riType" :refresh="showRiCoHelpList" @close="doClose" @doAssign="doAssignRiCo($event)" />
    </v-dialog>
  </page>
</template>
<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiRiCoHelpList from '@/components/core/common/dialog/MultiRiCoHelpList'
import { riTypes } from '@/const/common'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    commonAjaxMixin,
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiBusClsHelpList,
    MultiFundHelpList,
    MultiPolTypeHelpList,
    MultiRiCoHelpList
  },
  data() {
    return {
      menu: {},
      showBranchHelpList: false,
      showBusClsHelpList: false,
      showFundHelpList: false,
      showPolTypeHelpList: false,
      showRiCoHelpList: false,
      submitting: false,
      form: {
        currDateFrom: new Date(),
        currDateTo: new Date(),
        prevDateFrom: new Date(),
        prevDateTo: new Date(),
        acctPeriodFrom: new Date(),
        acctPeriodTo: new Date(),
        branch: 'All',
        fund: 'All',
        polType: 'All',
        busCls: 'All',
        riType: 'D',
        riCo: '',
        sortOrder: 'L',
        reportType: 'B',
        format: 'PDF',
        pbPrtParam: false
      },
      labels: {
        currDateFrom: 'Current Year Date From',
        currDateTo: 'To',
        prevDateFrom: 'Previous Year Date From',
        prevDateTo: 'To',
        acctPeriodFrom: 'Accounting Period From',
        acctPeriodTo: 'To',
        branch: 'Branch',
        fund: 'Fund',
        polType: 'Policy Type',
        busCls: 'Business Class',
        riType: 'RI Type',
        riCo: 'RI Company',
        sortOrder: 'Sort Order',
        reportType: 'Report Type',
        export: 'Export To',
        pbPrtParam: 'Print Run Time Parameters'
      },
      sortOrderList: [
        { label: 'Claim Year', value: 'C' },
        { label: 'Loss Year', value: 'L' },
        { label: 'Underwriting Year', value: 'U' }
      ],
      reportTypeList: [
        { label: 'Both', value: 'B' },
        { label: 'Detail', value: 'D' },
        { label: 'Summary', value: 'S' }
      ],
      supportedFormat: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    riTypeList() {
      const list = Object.freeze(riTypes)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    riCoDisabled() {
      return this.form.riType === 'D'
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.riClmSum
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async riTypeChanged() {
      this.form.riCo = ''
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
      this.showBusClsHelpList = false
      this.showFundHelpList = false
      this.showPolTypeHelpList = false
      this.showRiCoHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignBusCls(obj) {
      this.form.busCls = []
      this.form.busCls = obj.finalSelectedItems.toString()
    },
    async doAssignFund(obj) {
      this.form.fund = []
      this.form.fund = obj.finalSelectedItems.toString()
    },
    async doAssignRiCo(obj) {
      this.form.riCo = []
      this.form.riCo = obj.finalSelectedItems.toString()
      if (this.form.riCo === 'All') {
        this.form.riCo = ''
      }
    },
    async doAssignPolType(obj) {
      this.form.polType = []
      this.form.polType = obj.finalSelectedItems.toString()
    }
  }
}
</script>
